export const versionNames = `
  fft01
  fft02
  fft44
  fft47
  fft47pointers
  fft48
  fft60
  fft99b
  fft99c
  fftKiss
  fftKiss2
`.trim().split(/\s+/);
